export const ARTICLE_CONTENT_WRAPPER_WIDTH_ATTRIBUTE = "--article-content-wrapper-width";
